import { render, staticRenderFns } from "./ControlCoupon.vue?vue&type=template&id=050657a8"
import script from "./ControlCoupon.vue?vue&type=script&lang=js"
export * from "./ControlCoupon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports